import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Modal, Tabs } from "antd";
import EmployeeList from "./list";
import PositionList from "./position";
import axios from "axios";
import { SubscriptionInfo, UserInfo } from "../../../context";
import MerchantLayout from "../../layout/MerchantLayout";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantPayroll from "./payroll";
import MerchantGovtContribution from "./govt-contribution";
import InactiveEmployeeList from "./inactive-list";
import DepartmentList from "./department";

const MerchantEmployee = () => {
  const [positionList, setPositionList] = useState({ data: [], ready: false });
  const [departmentList, setDepartmentList] = useState({
    data: [],
    ready: false,
  });
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();
  // console.log(
  //   "subscriptionDetails",
  //   subscriptionDetails.data.subsmerchantfeat.account_limit
  // );
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });

  const [unemployeeList, setUnemployeeList] = useState({
    data: [],
    ready: false,
  });

  const items = [
    {
      key: "1",
      label: `Employee 201 `,
      children: (
        <EmployeeList
          positionList={positionList}
          departmentList={departmentList}
          // rerun={() => getPositionList()}
          limit={subscriptionDetails.data.subsmerchantfeat.account_limit}
          employeeList={employeeList}
          getEmployeeList={() => getEmployeeList()}
          getUnemployeeList={() => getUnemployeeList()}
        />
      ),
    },
    {
      key: "5",
      label: `Employee 202`,
      children: (
        <InactiveEmployeeList
          // positionList={positionList}
          // rerun={() => getPositionList()}
          // limit={subscriptionDetails.data.subsmerchantfeat.account_limit}
          unemployeeList={unemployeeList}
          // getUnemployeeList={() => getUnemployeeList()}
        />
      ),
    },
    {
      key: "2",
      label: `Position`,
      children: (
        <PositionList
          positionList={positionList}
          rerun={() => getPositionList()}
          limit={subscriptionDetails.data.subsmerchantfeat.account_limit}
        />
      ),
    },
    {
      key: "6",
      label: `Department`,
      children: (
        <DepartmentList
          departmentList={departmentList}
          rerun={() => getDepartmentList()}
          limit={subscriptionDetails.data.subsmerchantfeat.account_limit}
        />
      ),
    },
    {
      key: "3",
      label: `Payroll`,
      children: <MerchantPayroll employeeList={employeeList} />,
    },
    {
      key: "4",
      label: `Govt Contribution`,
      children: <MerchantGovtContribution />,
    },
  ];

  const getPositionList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/position-list", { params })
      .then((response) => {
        const data = response.data;
        setPositionList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getDepartmentList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/department-list", { params })
      .then((response) => {
        const data = response.data;
        // console.log("DATA: ", data);
        setDepartmentList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getEmployeeList = useCallback(() => {
    var params = { user_id: userData.data.id, status: 1 };
    axios
      .get("user/merchant/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getUnemployeeList = useCallback(() => {
    var params = { user_id: userData.data.id, status: 0 };
    axios
      .get("user/merchant/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setUnemployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getPositionList();
    getDepartmentList();
    getEmployeeList();
    getUnemployeeList();
  }, [getPositionList, getDepartmentList, getEmployeeList, getUnemployeeList]);

  return (
    <MerchantLayout>
      <Tabs defaultActiveKey="1" items={items} />
      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantEmployee;
